var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "featured-articles", style: _vm.paddingStyles },
      [
        _c(
          "div",
          { staticClass: "featured-articles__header-container" },
          [
            _vm.featuredArticles.preHeading
              ? _c(
                  "h4",
                  {
                    staticClass: "preheader featured-articles__preheading",
                    class: _vm.featuredArticles.textColor
                  },
                  [_vm._v(_vm._s(_vm.featuredArticles.preHeading))]
                )
              : _vm._e(),
            _vm.featuredArticles.heading
              ? _c(
                  "h2",
                  {
                    staticClass: "h3 featured-articles__heading",
                    class: _vm.featuredArticles.headingColor
                  },
                  [_vm._v(_vm._s(_vm.featuredArticles.heading))]
                )
              : _vm._e(),
            _vm.featuredArticles.subHeading
              ? _c(
                  "h3",
                  {
                    staticClass: "subheader featured-articles__subheading",
                    class: _vm.featuredArticles.textColor
                  },
                  [_vm._v(_vm._s(_vm.featuredArticles.subHeading))]
                )
              : _vm._e(),
            _vm.$mq !== "mobile"
              ? _c("div", { staticClass: "controls-container" }, [
                  _c("div", { staticClass: "arrows" }, [
                    _c(
                      "div",
                      {
                        staticClass: "arrow arrow-prev",
                        on: { click: _vm.slidePrev }
                      },
                      [
                        _c("icon", {
                          attrs: {
                            "fill-class": _vm.featuredArticles.arrowColor,
                            name: "chevron-left",
                            size: "14px"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "arrow arrow-next",
                        on: { click: _vm.slideNext }
                      },
                      [
                        _c("icon", {
                          attrs: {
                            "fill-class": _vm.featuredArticles.arrowColor,
                            name: "chevron-right",
                            size: "14px"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _vm.featuredArticles.enableCta && _vm.$mq !== "mobile"
              ? _c(
                  "v-button",
                  {
                    staticClass: "featured-articles__view-all-button",
                    class: _vm.featuredArticles.ctaLayout,
                    attrs: { href: "/blogs/all", tag: "a" }
                  },
                  [_vm._v("View All")]
                )
              : _vm._e()
          ],
          1
        ),
        _vm.$mq !== "mobile"
          ? _c(
              "swiper",
              {
                ref: "blogSectionArticlesDesktop",
                staticClass: "featured-articles__articles",
                attrs: { options: _vm.desktopOptions }
              },
              _vm._l(_vm.featuredArticles.articles, function(article, index) {
                return _c("swiper-slide", { key: index }, [
                  _c(
                    "a",
                    {
                      key: index,
                      staticClass: "featured-articles__article clip-transition",
                      class: _vm.featuredArticles.textColor,
                      attrs: { href: article.articleUrl }
                    },
                    [
                      _c("div", {
                        staticClass: "featured-articles__image",
                        style: {
                          backgroundImage: "url('" + article.articleImg + "')"
                        },
                        attrs: { "data-clip-img": "" }
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "preheader featured-articles__preheading"
                        },
                        [_vm._v(_vm._s(article.blogName))]
                      ),
                      _c("h5", { staticClass: "h5 featured-articles__title" }, [
                        _vm._v(_vm._s(article.articleTitle))
                      ]),
                      _c(
                        "v-link",
                        {
                          staticClass:
                            "featured-articles__read-more link link--primary"
                        },
                        [_vm._v("Read More")]
                      )
                    ],
                    1
                  )
                ])
              }),
              1
            )
          : _vm._e(),
        _c(
          "swiper",
          {
            ref: "blogSectionArticlesMobile",
            staticClass: "featured-articles__articles--mobile",
            attrs: { options: _vm.mobileOptions }
          },
          _vm._l(_vm.featuredArticles.articles, function(article, index) {
            return _c("swiper-slide", { key: index }, [
              _c(
                "a",
                {
                  staticClass: "featured-articles__slide clip-transition",
                  class: _vm.featuredArticles.textColor,
                  attrs: { href: article.articleUrl }
                },
                [
                  _c("div", {
                    staticClass: "featured-articles__image",
                    style: {
                      backgroundImage: "url('" + article.articleImg + "')"
                    },
                    attrs: { "data-clip-img": "" }
                  }),
                  _c(
                    "span",
                    { staticClass: "preheader featured-articles__preheading" },
                    [_vm._v(_vm._s(article.blogName))]
                  ),
                  _c("h5", { staticClass: "h5" }, [
                    _vm._v(_vm._s(article.articleTitle))
                  ]),
                  _c(
                    "v-link",
                    {
                      staticClass:
                        "featured-articles__read-more link link--primary"
                    },
                    [_vm._v("Read More")]
                  )
                ],
                1
              )
            ])
          }),
          1
        ),
        _vm.$mq === "mobile"
          ? _c("div", { staticClass: "controls-container" }, [
              _c(
                "div",
                { staticClass: "pagination-dots" },
                _vm._l(_vm.featuredArticles.articles, function(article, index) {
                  return _c("div", {
                    key: "dot-" + index,
                    staticClass: "dot",
                    class: [_vm.dotActive(index), "dot-" + index],
                    on: {
                      click: function($event) {
                        return _vm.slidePagination(index)
                      }
                    }
                  })
                }),
                0
              )
            ])
          : _vm._e(),
        _vm.featuredArticles.enableCta && _vm.$mq === "mobile"
          ? _c(
              "v-button",
              {
                staticClass: "featured-articles__view-all-button",
                class: _vm.featuredArticles.ctaLayout,
                attrs: { href: "/blogs/all", tag: "a" }
              },
              [_vm._v("View All")]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }